import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import styleB from '../../style'

import config from '../../../../config'

import Container from '../partials/Container'
import BillingTable from '../partials/BillingTable'

import access from '../../../../utils/access'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Payment', 'User', 'Auth', 'Config')
@observer
export class Billings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        active: {}
      }
    }
  }

  componentWillMount () {
    const _searchPayments = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _searchPayments()
        }

        this.props.Payment.getAllMassPayments()
      }, 500)
    }

    _searchPayments()
  }

  onItemClick (e) {
    e.preventDefault()
    const pId = e.currentTarget.dataset.pid

    if (!pId) {
      return
    }

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        active: {
          ...(this.state.editor.active.id === pId
            ? {}
            : { id: pId, active: true })
        }
      }
    })
  }

  onDownloadClick (e) {
    e.preventDefault()
    const pId = this.state.editor.active.id
    const accessToken = this.props.Auth.token.accessToken

    window.open(
      `${
        config.api_uri
      }/payment/payment/file/${pId}?x-auth-access-token=${accessToken}`,
      '_blank'
    )
  }

  onPaidClick (e) {
    e.preventDefault()

    const pId = this.state.editor.active.id

    if (!pId) {
      return
    }

    this.props.Payment.patchMassPayment(pId, 'paid', true)
  }

  onReloadClick (e) {
    const pId = this.state.editor.active.id
    console.log(pId)
    if (!pId) {
      return
    }

    this.props.Payment.reloadMassPayment(pId)
  }

  render () {
    const showNavigationArea =
      access.adminTransactions(this.props.User.me.permissions || {}) &&
      this.state.editor.active.id
    return (
      <Container {...this.props}>
        <Row>
          <Col xs='12' lg='6'>
            <h2 className={css(styleB.headers.h2)}>Mass Payments</h2>
          </Col>
          <Col>
            {!showNavigationArea ? null : (
              <NavigationArea
                onDownloadClick={this.onDownloadClick.bind(this)}
                onPaidClick={this.onPaidClick.bind(this)}
                onReloadClick={this.onReloadClick.bind(this)}
              />
            )}
          </Col>
        </Row>
        <Row>
          <BillingTable
            theme={THEME_LIST[this.props.Config.theme]}
            editor={this.state.editor}
            payments={this.props.Payment.mass.slice()}
            onItemClick={this.onItemClick.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

export const NavigationArea = props => {
  return (
    <Row style={props.style || {}}>
      <Col>
        <span
          onClick={props.onDownloadClick}
          className={css(styleB.buttons.button, styleB.buttons.red)}
        >
          Download
        </span>
      </Col>
      <Col>
        <span
          onClick={props.onPaidClick}
          className={css(styleB.buttons.button, styleB.buttons.red)}
        >
          Paid
        </span>
      </Col>
      <Col xs='12' lg='2'>
        <span
          onClick={props.onReloadClick}
          className={css(
            styleB.buttons.button,
            styleB.buttons.reload,
            styleB.buttons.red
          )}
        >
          <i className={'fa fa-redo'} />
        </span>
      </Col>
    </Row>
  )
}

export default Billings



// WEBPACK FOOTER //
// ./src/components/Community/Main/Billings/index.js